import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createPresent,
  getPresent,
  getPresents,
  updatePresent,
  updateStatus,
} from '../../api/presentsApi';

export const fetchPresents = createAsyncThunk(
  'presents/fetchPresents',
  async ({ filters, pagination }, thunkAPI) => {
    try {
      const response = await getPresents(filters, pagination);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const addPresent = createAsyncThunk(
  'presents/addPresent',
  async (data, thunkAPI) => {
    try {
      const response = await createPresent(data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const changePresent = createAsyncThunk(
  'presents/changePresent',
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await updatePresent(id, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const changeStatus = createAsyncThunk(
  'presents/changeStatus',
  async ({ id, status }, thunkAPI) => {
    try {
      const response = await updateStatus(id, status);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
